import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {
  action: string;
  btnName: string;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data) {
    this.action = data.action;

    this.setBtnName(this.action);
  }

  ngOnInit() {
  }

  close_dialogue(btnClicked: any) {
    this.dialogRef.close(btnClicked);
  }

  setBtnName(action: any) {
    if (this.action === 'exit') {
      // this.btnName = 'EXIT';
      this.btnName = 'configurator_db.exit';
    } else if (this.action === 'finish') {
      // this.btnName = 'OK';
      this.btnName = 'common.ok';
    } else if (this.action === 'dfos') {
      // this.btnName = 'PROCCEED';
      this.btnName = 'config_exception.procceed';
    } else if (this.action === 'reconfigure') {
      // this.btnName = 'RECONFIGURE';
      this.btnName = 'config_exception.reconfigure';
    } else if (this.action === 'lineConfig') {
      // this.btnName = 'CONFIGURE';
      this.btnName = 'configurator_db.config_btn';
    }
  }
}
